module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"hidden":"关闭"},"en":{"hidden":"close"},"fr":{"hidden":"Fermer"},"de":{"hidden":"Schließen"},"jp":{"hidden":"閉じる"},"es":{"hidden":"Cerrar"},"pt":{"hidden":"Fechar"},"it":{"hidden":"Chiudi"},"tw":{"hidden":"關閉"}}')
  delete Component.options._Ctor
}
